import { default as _get } from 'lodash.get';
import Cookies from 'js-cookie';
import { APP_SWITCHER_TARGET_ID, MENU_DOM_ID } from '../constants';
import { default as loadStatechart } from './statechart';
const logoutClickHandler = (e) => {
    const statechart = loadStatechart();
    e.stopPropagation();
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    statechart.sendEvent('logout');
};
const getLogoutButton = (translations) => {
    const btn = document.createElement('button');
    btn.addEventListener('click', logoutClickHandler);
    btn.addEventListener('keyup', logoutKeyupHandler);
    btn.classList.add('mas-logout-button');
    btn.textContent = t('app_switcher.logout', translations);
    return btn;
};
// AUTHENTICATION
const isAuthenticated = () => Boolean(Cookies.get('JSESSIONID'));
const logout = () => Cookies.remove('JSESSIONID');
const getOptionFunc = (options) => (key = '') => _get(options, key);
const menuDomRemover = (state) => () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const options = state.getData('options');
    const getOptions = getOptionFunc(options);
    const targetId = getOptions('targetId') || APP_SWITCHER_TARGET_ID;
    const menuDomNode = document.querySelector(`#${MENU_DOM_ID}_${targetId}`);
    menuDomNode?.remove();
    return true;
};
const logoutKeyupHandler = (e) => {
    if (e?.key === 'Enter') {
        logoutClickHandler(e);
    }
};
// TRANSLATION FUNCTION
const t = (key, translations) => _get(translations, key, 'err_missing_translation');
export { t, getOptionFunc, logout, isAuthenticated, menuDomRemover, logoutKeyupHandler, getLogoutButton, logoutClickHandler };
